import React, { useState } from 'react';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
import { OtpInput } from 'reactjs-otp-input';
import '../App.css';
import Back from '../components/backComponent';


function Verify() {

    const [otp, setOtp] = useState('');

    const handleChange = (otp: any) => {
        setOtp(otp)

        console.log(otp)

        // init a verify post
        if (otp.length === 6) {

            //
            console.log('OTP Submitted');
        }
    };

    const handleSubmit = (event: any) => {
      
        event.preventDefault();
        
        
        console.log(otp)
        
  
        // if (!/\S+@\S+\.\S+/.test(email)) {
        //   setEmailError("Please enter your email")
  
        //   return
        // }
  
        // if ('' === password) {
        //   setPasswordError('Please enter a password')
  
        //   return
        // }
  
        // if (password.length < 7) {
        //   setPasswordError('password must be 8 characters or longer')
  
        //   return
        // }
  
        // e.preventDefault()
    
    
      } 

    return (
      <section className='dark:bg-dark h-full'>
          <Back title='Login'/>
        <div className="flex flex-col items-center justify-center px-6 py-1 mx-auto h-[60vh] dark:bg-gray-800 dark:text-white">
          
            <AppLogo />
            <AppTitle title={'Verify OTP'} description={'Enter code from email'} />

            <div className="w-full md:mt-0 sm:max-w-md xl:p-0 mt-5">
              <div className="p- space-y-4 md:space-y-6 sm:p-8">
                    <form className="space-y-4 md:space-y-5" onSubmit={handleSubmit}>
                      <div className='mb-5'>
                        <OtpInput shouldAutoFocus={true} className='flex mx-2 bg-gray-50 text-gray-900 rounded-lg  focus:ring-grey-600 focus:border-grey-600 block w-full py-1  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'  inputStyle={{background: 'none', width: '2.67rem', height: '3rem'  }} value={otp} onChange={handleChange} numInputs={6} separator={''} />
                      </div>
                      <div className='flex flex-col space-y-4 '>
                        <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Verify</button>
                        
                      </div>
                  </form>
                </div>
            </div>
        </div>
      </section>
    )
}

export default Verify